import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlContrato = '/service/materiais/contrato/'

class ConsultaPrestadoresServicosEmpresasTerceirizadasService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            tipo: filtro.tipoContrato ? filtro.tipoContrato.map(e => e.value) : '',
            exercicio: filtro.exercicioContrato,
            numero: filtro.numeroContrato,
            objeto: filtro.objetoContrato,
            nomeContratado: filtro.nomeContratadoContrato,
            tipoCompra: filtro.tipoCompra ? filtro.tipoCompra.value : null,
            dataValidadeFinalInicio: filtro.dataValidadeInicial ? moment(filtro.dataValidadeInicial).format('YYYY-MM-DD') : '',
            dataValidadeFinalFim: filtro.dataValidadeFinal ? moment(filtro.dataValidadeFinal).format('YYYY-MM-DD') : '',
        }

        return this.conex.post(urlContrato + 'consultaPrestadoresServicosEmpresasTerceirizadas/', JSON.stringify(data))
    }
}

export default ConsultaPrestadoresServicosEmpresasTerceirizadasService
